import mpx, { observable, watch } from '@mpxjs/core'
import {
  // createOrder,
  getRecommendGoods,
  getGoodsDetail,
  isGoodsWaitingPay,
  setPageShareConfig,
} from '../../../biz'
import { mallPay } from '../../../biz/pay'
import { sendRecOrderRequest } from '../../../common_methods'
import {
  EnumGoodsStatus,
  EnumGoodsDetailIsSpike,
  EnumRouteType,
} from '../../../defines/enums'
import { GlobalEnv, initEnv, login } from '../../../global_env'
import { URLQueries } from '../../../global_env/url_query'
import { getErrorMessage } from '../../../utils/error'
import { navigateTo, setTitle, redirectTo } from '../../../utils/ui'
import { FnBridge } from './fn_bridge'
import { isSoldOut } from './judge'
import { Track, createErrorTrack } from './track'
import { runAsyncHooks, runHooks } from './utils'
import {
  getBizExtraData,
  getTrackUrl,
  hideGoodDetailModule,
} from '../../../../js/util'
import {
  trackEvent,
  is,
  query,
  hashQuery,
  utils,
  xenv,
  goTo,
  build,
} from '@didi/webx-js'
import { callIsLogin } from '@/lib/webx/global_env/login'
import { showVersion } from './const'
import {
  TechPageErrorNoFromAndXenv,
  TechPageErrorXenvError,
  TechGoodsDetailCreateOrderError,
} from '@/lib/webx/tech_error_track'
import { TransferStation } from '../../../utils/transfer_station'
import { b64DecodeUnicode } from '../../../utils/b64DecodeUnicode'
import {
  getformateLangMessage,
  getProdConfFromApollo,
} from '../../../global_env/get_prod_config'
import { dealPageErrno, Errno } from '@/lib/webx/api'
import { restoreTokenToUrl } from '../../../../js/token-guard'
// import { proxySnakeCase } from '@/lib/webx/utils/format'
// import { createOrder } from '@didi/trade-sdk/lib/quartz-mall'

// TODO: 临时改紧急 bugX
const extra = { lang: GlobalEnv.lang }
if (__mpx_mode__ === 'web') {
  extra.source = getTrackUrl()
}
window.mallTrackEvent = function (key, name, events) {
  trackEvent(key, name, {
    fr: xenv(),
    ...extra,
    ...events,
  })
}

/**
 * PageConfig {
 * needLogin,
 * needLocation
 * hooks: {
 *   beforeGetDetail: () || [],
 *   afterGetDetail: () || [],
 *    beforeOrder: () || [], // async
 *    afterOrder: () || []
 *    beforeRender: () || []
 *  }
 * }
 */

const DefaultPageConfig = {
  needLogin: false,
  hooks: {},
}

/** 信贷channelId */
const creditChannelId = () => {
  switch (true) {
    case xenv() === 'passenger':
      return '3140738815205135'
    case xenv() === 'wxmp':
      return '3140738815205153'
    case xenv() === 'alimp':
      return '3140738821327261'
    default:
      return '3140738821315068'
  }
}

/** 不下线商品交互 */
const offlineGoodsHandler = async function () {
  const res = await mpx.showModal({
    type: 'confirm',
    title: this.$t('common.goodsOffline'),
    confirmText: this.$t('common.seeMoreDeals'),
    cancelText: this.$t('common.confirm'),
  })
  if (res.confirm) {
    navigateTo('index', {
      city_id: GlobalEnv.cityId,
      productType: URLQueries.getQuery('productType') || '',
    })
  }
}

/** 待支付商品交互 */
const waitingPayGoodsHandler = async function (hooks) {
  const res = await mpx.showModal({
    type: 'confirm',
    title: this.$t('common.pendingPayment'),
    confirmText: this.$t('common.PayNow'),
    cancelText: this.$t('common.cancel'),
  })
  if (res.confirm) {
    try {
      const id = this.$data.$_.goods.extension.orderId
      await mallPay(this.$data.$_.goods.extension.payInfo, {
        mp: {
          successUrl: '',
          successParams:
            this.$data.$_.goods.isSpike === EnumGoodsDetailIsSpike.Bogo
              ? {
                  bogo_show_send_guide: 1,
                }
              : {},
        },
        orderId: id,
      })
      try {
        Track.buySuccess.call(this, this.$data.$_.goods.extension)
      } catch (error) {}
      runAsyncHooks.call(this, hooks.afterOrder, {
        errno: 0,
        orderId: id,
        res,
      })
    } catch (error) {
      if (error?.code === 2) return
      runAsyncHooks.call(this, hooks.afterOrder, {
        errno: 1,
        error,
      })
    }
  }
}

/** 设置支付完成后跳转信息 */
const setPayExtra = function () {
  const prodConfTextFromApollo = getProdConfFromApollo(
    this.$data.$_.goods.productType,
    {
      searchKey: 'pay_result',
    }
  )
  if (
    this.$data.$_.goods.orderLandingPage &&
    this.$data.$_.goods.orderLandingButton
  ) {
    this.$data.$_.payExtra = {
      successUrl: this.$data.$_.goods.orderLandingPage,
      successText: this.$data.$_.goods.orderLandingButton,
    }
  } else if (
    prodConfTextFromApollo?.dache_btn_link &&
    !prodConfTextFromApollo?.dache_btn_hide
  ) {
    const successText = getformateLangMessage(
      prodConfTextFromApollo?.dache_btn_text
    )
    this.$data.$_.payExtra = {
      successUrl: prodConfTextFromApollo?.dache_btn_link,
      successText,
    }
  }
}

/** 获取商品详情 */
const getDetail = async function (hooks) {
  try {
    runHooks.call(this, hooks.beforeGetDetail)
    const data = await getGoodsDetail(URLQueries.getQuery('id'))
    this.$data.goodsInstance = data.goods
    const goods = data.goods?.goodsData
    if (
      goods.showVersion === showVersion.nOrder &&
      goods.useTripNumPackage?.[0]?.package
    ) {
      goods.package = goods.useTripNumPackage[0].package
    }
    this.$data.$_.goods = goods
    runHooks.call(this, hooks.afterGetDetail, goods)
    this.pageStyle = {
      backgroundColor: '#fcfdfe',
    }
    this.$data.$_.buyerList = data.buyerList
    Number(goods.auditStatus) === EnumGoodsStatus.Offline &&
      offlineGoodsHandler.call(this)
    // TODO: 老逻辑里，秒杀页面不展示待支付商品，确认一下：1、找后端确认秒杀有没有这个字段和逻辑；2、和产品确认 -> 判断是漏了，还是确实不能展示 -> 这里需要不需要特殊处理
    isGoodsWaitingPay(goods) &&
      goods.is_sale !== 0 &&
      waitingPayGoodsHandler.call(this, hooks)
    setPayExtra.call(this)
  } catch (error) {
    if (__mpx_mode__ === 'web') {
      document.getElementById('loading')?.remove()
    }
    this.pageErrno = dealPageErrno(error)
    if (error.errno === Errno.GoodsCanNotBuy) {
      redirectTo('index')
    }
  }
}

/** 生成渲染数据 */
const render = function (hooks) {
  const goods = this.$data.$_.goods
  // 双重保证，避免后端刷缓存将n单商品刷为普通商品时展示
  const isNorder =
    goods.showVersion === showVersion.nOrder && goods.useTripNumPackage
  const queryInfo = Object.assign({}, query(), hashQuery())
  const MallRenderData = {
    template: 'normal',
    // TODO: 这里需要加个唯一 ID, 后面循环组件的话，key 用 name 不太保险，万一需要一个组件渲染两次
    components: [
      {
        name: 'top-header',
        data: {
          title: goods.goodsName,
          goodsType: goods.goodsType,
          desc: goods.extra && goods.extra.goodsTopText,
          currency: goods.currency,
          totalSave: goods.totalSave,
          couponNumber: goods.cardShow?.couponNumber,
          backgroundImage: goods.extra && goods.extra.goodsInfoPic,
          ...isSoldOut(goods),
        },
      },
      ...(isNorder
        ? [
            {
              name: 'n-coupon-packages',
              data: {
                list: goods.useTripNumPackage || [],
                currency: goods.currency,
                productType: goods.productType,
              },
            },
          ]
        : [
            {
              name: 'coupon-packages-list',
              data: {
                list: goods.package || [],
                currency: goods.currency,
                productType: goods.productType,
              },
            },
          ]),
      ...(goods.isSpike === EnumGoodsDetailIsSpike.Group
        ? [
            {
              name: 'group-rules',
              data: {},
            },
          ]
        : []),
      {
        name: 'rules',
        data: {
          goodsDesc: goods.goodsDesc,
        },
      },
      {
        name: 'city-info',
        data: {
          cityDesc: goods.cityDesc,
        },
      },
      {
        name: 'supplementar',
        data: {
          goodsExtraDesc: goods.goodsExtraDesc,
        },
      },
      {
        name: 'conditions',
        data: {},
      },
      {
        name: 'recommend-list',
        data: {
          list: this.$data.$_.recommendList,
          event: this.$data.$_.recOrder.event,
          isSoldOut: isSoldOut(goods).soldOut,
          isEnd: goods.endTime < goods.currentTime,
        },
        hide: hideGoodDetailModule('recommend-list'),
      },
      ...(goods.isSale === 0 || queryInfo?.only_show
        ? []
        : [
            {
              name: 'operations',
              data: {
                isLogin: GlobalEnv.isLogin,
                isSoldOut: isSoldOut(goods).soldOut,
                price: goods.showCash,
                currency: goods.currency,
                showText: goods.showText,
                showVersion: goods.showVersion,
                markType: goods.markType,
                goods: goods,
                creditInfo: goods.creditInfo,
                buyerList: this.$data.$_.buyerList,
                routeType: goods.routeType,
                routePrice: goods.routePrice,
                routeFromPop: false,
              },
            },
          ]),
    ],
  }
  // 如果是线路价
  if (goods.isSpike === EnumGoodsDetailIsSpike.Route && goods.routeType) {
    // 支持query 中指定线路
    let queryRouteInfo = null
    try {
      const _info = URLQueries.getQuery('routeinfo')
      queryRouteInfo =
        _info && JSON.parse(decodeURIComponent(b64DecodeUnicode(_info)))
    } catch (err) {
      queryRouteInfo = null
    }
    const routeInfoScope = queryRouteInfo || goods
    // TODO 线路套餐数据是否被处理为驼峰
    MallRenderData.components.splice(2, 0, {
      name: 'route-box',
      data: {
        pageType: 1,
        routeType: goods.routeType,
        productType: goods.productType,
        goodsId: goods.goodsId,
        startRoute: {
          name: routeInfoScope.starting_name || routeInfoScope.startingName,
          lat: routeInfoScope.starting_lat || routeInfoScope.startingLat,
          lng: routeInfoScope.starting_lng || routeInfoScope.startingLng,
        },
        endRoute: {
          name: routeInfoScope.dest_name || routeInfoScope.destName,
          lat: routeInfoScope.dest_lat || routeInfoScope.destLat,
          lng: routeInfoScope.dest_lng || routeInfoScope.destLng,
        },
      },
    })
  }
  const res = runHooks.call(this, hooks.beforeRender, MallRenderData)
  this.MallRenderData = res || MallRenderData
  window.PerfTrack?.coreImageReady?.({
    url: utils.webpUrl(goods.extra.goodsInfoPic),
  })
  window.PerfTrack?.customTTI?.({
    resources: [
      utils.webpUrl(goods.extra.goodsInfoPic),
      'https://dpubstatic.udache.com/static/dpubimg/fb241e2d-bfab-4239-9300-eba1268e706a.png',
      'https://dpubstatic.udache.com/static/dpubimg/f809b2f3-7596-4461-aa82-23d6777e200c.png',
    ],
  })
}

const ObservableGlobalEnv = observable(GlobalEnv)

const getPageInfoAndRender = async function (hooks) {
  // 两个请求并发，但是要保证 detail 回来，运行完 render 函数，有了 MallRenderData 之后，再更新推荐的渲染数据
  const p1 = getDetail.call(this, hooks)
  const p2 = GlobalEnv.isLogin
    ? getRecommendGoods({
        goodsId: URLQueries.getQuery('id'),
      })
    : Promise.resolve({ list: [] })
  window.PerfTrack?.requestBegin?.()
  try {
    await p1
    render.call(this, hooks)
  } catch (error) {} // 错误上面已经处理了
  window.PerfTrack?.responseReady?.()
  this.$nextTick(() => {
    window.PerfTrack?.domReady?.({ isKey: true })
  })
  const { list, event } = await p2
  this.$data.$_.recommendList = list
  // TODO: 秒杀的时候，老逻辑没有保存算法埋点数据？确认：故意的还是漏了？
  this.$data.$_.recOrder.event = event
  // // TODO: 坏写法，这里实际上耦合的组件名称，想换组件就难了。。。远期解决办法：二次标注，组件加属性表明我是推荐组件或者是什么组件，实际渲染用 name，逻辑名称和渲染名称分开；或者只暴露数据，拼数据留给组件层自己玩。
  // this.$nextTick(() => {
  //   Track.pageShow.call(this)
  // })
  if (Array.isArray(this.MallRenderData.components)) {
    const components = this.MallRenderData.components.find(
      component => component.name === 'recommend-list'
    )
    components && (components.data.list = list)
  }
}
/**
 * 检查商品使用城市
 * @param {*} goods 商品
 */
const checkGoodsCityid = function () {
  if (this.pageErrno) {
    return
  }
  const goods = this?.$data?.$_?.goods || {}
  // 仅在端内检测
  if (is('passenger')) {
    // 以下保留原有逻辑
    const cityId = Number(GlobalEnv.locationInfo?.cityId)
    // 全国商品不处理
    if (Number(goods.cityId) === 0) {
      return
    }
    const goodsCityid = goods.cityId?.split(',') || []
    if (
      !cityId ||
      Number(cityId) === -1 ||
      goodsCityid.map(item => Number(item)).indexOf(cityId) === -1
    ) {
      mpx.showToast({
        title: this.$t('goodsDetail.limitCityMsg'),
        icon: 'none',
      })
      return
    }
  }
  if (goods.notifyToast) {
    mpx.showToast({
      title: goods.notifyToast,
      icon: 'none',
    })
  }
}

// const _createOrder = lockFn(async function (hooks, arg) {
//   try {
//     if (!GlobalEnv.isLogin) {
//       await login()
//       return
//     }
//     if (this.$data.$_.isFinished) {
//       mpx.showToast({
//         title: this.$t('spikeDetail.promotionEnded'),
//         icon: 'none',
//       })
//       return
//     }
//     if (this.$data.$_.isSoldOut) {
//       mpx.showToast({
//         title: this.$t('spikeDetail.goodsSoldOut'),
//         icon: 'none',
//       })
//       return
//     }
//     const params = {
//       goods_id: URLQueries.getQuery('id'),
//     }
//     if (arg?.[0]?.source_id) {
//       params.source_id = arg?.[0]?.source_id
//     }
//     this.$data.$_.goods.disRule &&
//       this.$data.$_.goods.disRule.disId &&
//       Object.assign(params, {
//         dis_id: this.$data.$_.goods.disRule.disId,
//       })
//     const { goodsId, routeType } = this.$data.$_.goods
//     const _args = (arg && arg[0]) || {}
//     /** 以活动的方式进行下单 */
//     if (_args.orderBySpike) {
//       const routeInfo = TransferStation.routeInfo[Number(goodsId)]
//       const _orderInfo = {}
//       switch (_args.orderBySpike) {
//         /** 线路套餐-参数 */
//         case EnumGoodsDetailIsSpike.Route:
//           console.log('-----this.$data.$_.route_type ', routeType)
//           if (routeType !== EnumRouteType.End) {
//             _orderInfo.starting_name = routeInfo?.startRoute?.name
//             _orderInfo.starting_lat = String(routeInfo?.startRoute?.lat)
//             _orderInfo.starting_lng = String(routeInfo?.startRoute?.lng)
//           }
//           if (routeType !== EnumRouteType.Start) {
//             _orderInfo.dest_name = routeInfo?.endRoute?.name
//             _orderInfo.dest_lat = String(routeInfo?.endRoute?.lat)
//             _orderInfo.dest_lng = String(routeInfo?.endRoute?.lng)
//           }
//           params.order_info = _orderInfo
//           break
//       }
//     }
//     const activityType = _args.orderBySpike
//     const res = await createOrder(activityType, this.$data.$_.goods, {
//       orderBySpike: _args.orderBySpike,
//       params,
//     })
//     const { pay_info: payInfo, id, credit_info, group_id } = res.data || {}
//     return { payInfo, id, credit_info, group_id }
//   } catch (error) {
//     if (error && error.statusCode && error.statusCode >= 500) {
//       mpx.showToast({
//         title: this.$t('common.sellFast'),
//         icon: 'none',
//       })
//     } else if (error.message === 'Response Error.') {
//       const { errno, errmsg } = error.extra
//       switch (errno) {
//         case 12028:
//           mpx.showModal({
//             content: this.$t('common.unavailableBuy'),
//             showCancel: false,
//           })
//           break
//         case 11004:
//           mpx
//             .showModal({
//               content: this.$t('common.goodsOffline'),
//             })
//             .then(res => {
//               if (res.confirm) {
//                 navigateTo('index', {
//                   city_id: GlobalEnv.cityId,
//                   channelId: GlobalEnv.channelId,
//                 })
//               }
//             })
//           break
//         default:
//           mpx.showToast({
//             title: errmsg,
//             icon: 'none',
//           })
//       }
//     } else if (error.message === 'Spike Error.') {
//       // TODO 迁移后 商品下线、售罄、未开始按钮都是不可点击态，且后端不会返回对应字段，待测试确定后删除
//       const { is_finished, is_soldout, is_started } = error.res
//       if (is_finished === 1) {
//         // 商品下线
//         mpx.showToast({
//           title: this.$t('spikeDetail.promotionEnded'),
//           icon: 'none',
//         })
//         this.$data.$_.isFinished = true
//       } else if (is_soldout === 1) {
//         // 先判断库存，再判断开始时间 售罄
//         mpx.showToast({
//           title: this.$t('spikeDetail.goodsSoldOut'),
//           icon: 'none',
//         })
//         this.$data.$_.isSoldOut = true
//         getPageInfoAndRender.call(this, hooks)
//       } else if (is_started === 0) {
//         // 未开始
//         mpx.showToast({
//           title: this.$t('spikeDetail.startSoon'),
//           icon: 'none',
//         })
//         getPageInfoAndRender.call(this, hooks)
//       } else {
//         mpx.showToast({
//           title: getErrorMessage(error),
//           icon: 'none',
//         })
//       }
//     } else if (error.message === 'limitSale') {
//       // TODO 限购也有后端直接返回errmsg 代码待删除
//       mpx.showToast({
//         title: this.$t('spikeDetail.limitSale'),
//         icon: 'none',
//       })
//     } else {
//       mpx.showToast({
//         title: getErrorMessage(error),
//         icon: 'none',
//       })
//     }
//   }
// })

export const initBaseFlow = async (PageConfig = {}) => {
  try {
    if (is('miniprogram') && !query().from && !query().xenv) {
      TechPageErrorNoFromAndXenv()
    }
    if (is('miniprogram') && query().xenv === 'h5') {
      TechPageErrorXenvError()
    }
  } catch (error) {}
  let needLocation
  // 抖音小程序整改，不需要定位
  if (xenv() === 'dymp') {
    needLocation = false
  } else {
    needLocation =
      typeof PageConfig.needLocation === 'boolean'
        ? PageConfig.needLocation
        : true
  }
  console.log('-initBaseFlow--needLocation', needLocation)
  await initEnv({
    needLocation,
    needLogin: PageConfig.needLogin,
    beforeInitPlantFormFn: () => {
      setTitle(PageConfig.title || mpx.i18n.t('home.title'))
    },
  })
  // setI18n(GlobalEnv.lang)
  document.body.classList?.add(GlobalEnv.lang.toLowerCase())
  // if (PageConfig.needLogin && !GlobalEnv.loginInfo.token) {
  //   await login()
  // }
}

const _afterCreateOrder = async (res, options) => {
  try {
    const { pay_info: payInfo, id, group_id, credit_info } = res.data || {}
    if (!payInfo && !credit_info) return { isStop: true }
    if (credit_info) {
      if (!credit_info.url) return { isStop: true }
      const params = {
        token: GlobalEnv.loginInfo.token,
        channelId: creditChannelId(),
      }
      if (xenv() === 'wxmp') {
        params.from_weapp_to_h5 = 1
      }
      restoreTokenToUrl()
      goTo({
        url: build(credit_info.url, params),
      })
      return { isStop: true }
    }
    const successParams = {}
    if (options.isSpike === EnumGoodsDetailIsSpike.Bogo) {
      successParams.bogo_show_send_guide = 1
    }
    if (
      options.isSpike === EnumGoodsDetailIsSpike.Group &&
      options.activityType === EnumGoodsDetailIsSpike.Group
    ) {
      successParams.groupId = group_id
      successParams.orderId = id
      successParams.id = options.goodsId
    }
    return { successParams }
  } catch (error) {
    return Promise.reject(error)
  }
}

const _afterCreateOrderError = async (error, hooks) => {
  if (error && error.statusCode && error.statusCode >= 500) {
    mpx.showToast({
      title: this.$t('common.sellFast'),
      icon: 'none',
    })
  } else if (error.message === 'Response Error.') {
    const { errno, errmsg } = error
    switch (errno) {
      case 12028:
        mpx.showModal({
          content: this.$t('common.unavailableBuy'),
          showCancel: false,
        })
        break
      case 11004:
        mpx
          .showModal({
            content: this.$t('common.goodsOffline'),
          })
          .then(res => {
            if (res.confirm) {
              navigateTo('index', {
                city_id: GlobalEnv.cityId,
                channelId: GlobalEnv.channelId,
              })
            }
          })
        break
      default:
        mpx.showToast({
          title: errmsg,
          icon: 'none',
        })
    }
  } else if (error.message === 'Spike Error.') {
    // TODO 迁移后 商品下线、售罄、未开始按钮都是不可点击态，且后端不会返回对应字段，待测试确定后删除
    const { is_finished, is_soldout, is_started } = error.res
    if (is_finished === 1) {
      // 商品下线
      mpx.showToast({
        title: this.$t('spikeDetail.promotionEnded'),
        icon: 'none',
      })
      this.$data.$_.isFinished = true
    } else if (is_soldout === 1) {
      // 先判断库存，再判断开始时间 售罄
      mpx.showToast({
        title: this.$t('spikeDetail.goodsSoldOut'),
        icon: 'none',
      })
      this.$data.$_.isSoldOut = true
      getPageInfoAndRender.call(this, hooks)
    } else if (is_started === 0) {
      // 未开始
      mpx.showToast({
        title: this.$t('spikeDetail.startSoon'),
        icon: 'none',
      })
      getPageInfoAndRender.call(this, hooks)
    } else {
      mpx.showToast({
        title: getErrorMessage(error),
        icon: 'none',
      })
    }
  } else if (error.message === 'limitSale') {
    // TODO 限购也有后端直接返回errmsg 代码待删除
    mpx.showToast({
      title: this.$t('spikeDetail.limitSale'),
      icon: 'none',
    })
  } else {
    mpx.showToast({
      title: getErrorMessage(error),
      icon: 'none',
    })
  }
}
export const PageDetailMixin = PageConfig => ({
  async onLoad() {
    // 旧详情页不再使用了，如果有旧详情页页面直接重定向到新页面
    const url = window.location.href.replace(
      'https://page.udache.com/quartz-mall/goodeDetail.html',
      'https://prod.didi.cn/quartz-mall/goodsDetail'
    )
    window.location.replace(url)

    window.PerfTrack?.jsReady?.()
    const config = (PageConfig = {
      ...DefaultPageConfig,
      ...PageConfig,
    })
    await initBaseFlow(config)
    // 这里不用 await 的原因：后面的异步操作可以并行，并且不会 throw error
    getPageInfoAndRender.call(this, config.hooks).then(() => {
      Track.pageShow.call(this)
      // 处理当定位城市不在商品的适用城市，弹toast
      checkGoodsCityid.call(this)
    })
    setPageShareConfig({
      pathname: 'goodsDetail',
      isDetail: true,
      shareConfigRequestParams: {
        goodsId: URLQueries.getQuery('id'),
      },
    }).catch(() => {})
    watch(
      () => ObservableGlobalEnv.isLogin,
      async n => n && getPageInfoAndRender.call(this, config.hooks)
    )
    FnBridge.createOrder = async arg => {
      try {
        if (!(arg && arg[0]?.disableOrderTrack)) {
          Track.createOrder.call(this, arg)
        }
        await runAsyncHooks.call(this, config.hooks.beforeOrder)
        GlobalEnv.hasRecOrderEventParams &&
          sendRecOrderRequest({
            ...GlobalEnv.eventParams,
            event_type: 'ord',
            event_time: Date.now(),
            item_id: URLQueries.getQuery('id'),
          })
        if (!GlobalEnv.isLogin) {
          await login()
          return
        }
        if (this.$data.$_.isFinished) {
          mpx.showToast({
            title: this.$t('spikeDetail.promotionEnded'),
            icon: 'none',
          })
          return
        }
        if (this.$data.$_.isSoldOut) {
          mpx.showToast({
            title: this.$t('spikeDetail.goodsSoldOut'),
            icon: 'none',
          })
          return
        }
        const params = {
          goods_id: URLQueries.getQuery('id'),
        }
        if (arg?.[0]?.source_id) {
          params.source_id = arg?.[0]?.source_id
        }
        this.$data.$_.goods.disRule &&
          this.$data.$_.goods.disRule.disId &&
          Object.assign(params, {
            dis_id: this.$data.$_.goods.disRule.disId,
          })
        const { goodsId, routeType } = this.$data.$_.goods
        const _args = (arg && arg[0]) || {}
        /** 以活动的方式进行下单 */
        if (_args.orderBySpike) {
          const routeInfo = TransferStation.routeInfo[Number(goodsId)]
          const _orderInfo = {}
          switch (_args.orderBySpike) {
            /** 线路套餐-参数 */
            case EnumGoodsDetailIsSpike.Route:
              console.log('-----this.$data.$_.route_type ', routeType)
              if (routeType !== EnumRouteType.End) {
                _orderInfo.starting_name = routeInfo?.startRoute?.name
                _orderInfo.starting_lat = String(routeInfo?.startRoute?.lat)
                _orderInfo.starting_lng = String(routeInfo?.startRoute?.lng)
              }
              if (routeType !== EnumRouteType.Start) {
                _orderInfo.dest_name = routeInfo?.endRoute?.name
                _orderInfo.dest_lat = String(routeInfo?.endRoute?.lat)
                _orderInfo.dest_lng = String(routeInfo?.endRoute?.lng)
              }
              params.order_info = _orderInfo
              break
          }
        }
        const activityType = _args.orderBySpike
        params.extra = JSON.stringify(getBizExtraData().bizOrderData)
        const createOptions = {}
        if (this.$data.$_.goods.isSpike === EnumGoodsDetailIsSpike.Group) {
          createOptions.isCreateNewGroup = _args.isCreateNewGroup
        }
        const successUrl =
          arg?.[0]?.orderBySpike === EnumGoodsDetailIsSpike.Group
            ? `${window.location.origin}/quartz-mall/goodsProcess.html`
            : ''
        const res = await this.$data.goodsInstance?.buy?.(activityType, {
          payOptions: {
            mini: {
              successUrl,
            },
          },
          params: params,
          createOptions,
          hooks: {
            afterCreateOrder: {
              async: true,
              action: _afterCreateOrder,
            },
          },
        })
        if (res?.isStop) return
        const { id, group_id } = res?.orderRes?.data || {}
        /* cspell: disable-next-line */
        Track.trippackagePaySw()
        // TODO: 小程序埋点修复。新版的小程序返回才 resolve.
        Track.buySuccess.call(this, res)
        GlobalEnv.hasRecOrderEventParams &&
          sendRecOrderRequest({
            ...GlobalEnv.eventParams,
            event_type: 'finish',
            event_time: Date.now(),
            item_id: URLQueries.getQuery('id'),
          })
        await runAsyncHooks.call(this, config.hooks.afterOrder, {
          errno: 0,
          orderId: id,
          orderBySpike: arg?.[0]?.orderBySpike,
          groupId: group_id,
        })
      } catch (error) {
        if (error?.code === 2) return
        const createOrderError = error?.errType === 'CREATEORDER'
        if (createOrderError) {
          _afterCreateOrderError.call(this, error, config.hooks)
          // createErrorTrack(error?.errno || 1, error, '0000')
          TechGoodsDetailCreateOrderError(error)
          return
        }
        if (!createOrderError && error?.errType && error?.errMsg) {
          mpx.showToast({
            title: error.errMsg,
            icon: 'none',
          })
          createErrorTrack(error?.errno || 1, error, '0000')
          return
        }
        await runAsyncHooks.call(this, config.hooks.afterOrder, {
          errno: 1,
          error,
        })
      }
    }
    FnBridge.refreshDetailInfo = async () =>
      getPageInfoAndRender.call(this, config.hooks)

    this.$nextTick(() => {
      callIsLogin()
    })
  },
  data: {
    $_: {
      isSpike: false,
      isFinished: false, // 活动结束标记，目前只有秒杀用了。秒杀下单返回 is_finished, 会记录到这里，再点击下单就不重复请求了。
      isSoldOut: false, // 售罄标记，目前只有秒杀用了。秒杀下单返回 is_soldout, 会记录到这里，再点击下单就不重复请求了。
      goods: {},
      recommendList: [],
      // 智能算法埋点数据
      recOrder: {
        event: {},
      },
      payExtra: {
        successUrl: '',
        successText: '',
      },
    },
    MallRenderData: {},
    pageStyle: {},
    buyerList: [], // 购买列表,length>1时展示在按钮左上方
    pageErrno: 0,
    goodsInstance: null,
  },
  methods: {
    $_onMallPageEvent(params) {
      const { method, args } = params.detail
      if (typeof this[method] === 'function') {
        this[method](...args)
      }
    },
  },
})
